import PublicArticleFolderImageActions from './publicArticleFolderImageActions';
import { entityPhotoHasImage } from '../../../utils/imageProxy';
import { getEntityImageConfig } from '../../entityImage/entityImageConfig';
import { Box, Grid } from '@mui/material';
import RichTextDisplay from '../../richText/RichTextDisplay';
import { plainTextFromRichText } from '../../../utils/richText';
import '../../../css/sites/siteDetailsContent.css';
import '../../../css/articleFolder/publicArticleFolder.css';

const PHOTO_OPTS = (({ imageField, documentField }) => ({ imageField, documentField }))(
  getEntityImageConfig('articleFolder'),
);

const PublicArticleFolderDetailsContent = ({ articleFolderDescription, articleFolder }) => {
  const hasDescription = Boolean(plainTextFromRichText(articleFolderDescription));
  const hasImage = entityPhotoHasImage(articleFolder, { ...PHOTO_OPTS, size: 'medium' });

  if (!hasDescription && !hasImage) {
    return null;
  }

  return (
    <Grid container spacing={3} className='siteDetailsContent_main_grid' alignItems="flex-start">
      {hasImage && (
        <Grid item xs={12} md={4} padding={3} className="publicArticleFolder_coverColumn">
          <Box className='siteDetailsContent_image_chiffre_box'>
            <PublicArticleFolderImageActions articleFolder={articleFolder} />
          </Box>
        </Grid>
      )}
      {hasDescription && (
        <Grid item xs={12} md={hasImage ? 8 : 12} padding={3}>
          <Box className='modeEtConsigne_box'>
            <RichTextDisplay html={articleFolderDescription} />
          </Box>
        </Grid>
      )}
    </Grid>
  );
};

export default PublicArticleFolderDetailsContent;
